import ForgotPWForm from "./forgottenPassword.view";
import { useNavigate } from "react-router";
import PATHS from "../../../constants/paths";
import * as ProviderService from "../../../services/ProviderService";
import showDialog from "../../utils/ShowDialog/ShowDialog";
import { useTranslation } from "react-i18next";

const LoginContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async (values) => {
    let title = "";
    let text = "";
    let icon = "";
    try {
      const okAction = () => {
        navigate(PATHS.EXT_LOGIN);
      };
      let result = await ProviderService.renewPassword(values);

      if (result) {
        title = t("forms.provider.messages.changePass.title");
        text = t("forms.provider.messages.changePass.success");
        icon = "success";
      }
      showDialog(title, text, icon, false, "OK", false, okAction);
    } catch (error) {
      // console.log("Error", error);
    }
  };

  return <ForgotPWForm onSubmit={handleSubmit}></ForgotPWForm>;
};

export default LoginContainer;
